<template>
  <ManualAddressForm
    v-model="postcode"
    :button-icon="buttonIcon"
    :success-icon="successIcon"
    :error-icon="errorIcon"
    :theme="theme"
    :label-class="labelClass"
    :btn-shadow="btnShadow"
    @submit="submit"
  />
</template>

<script>
import ManualAddressForm from './ManualAddressForm'

export default {
  name: 'SmartManualAddressForm',

  components: {
    ManualAddressForm
  },

  props: {
    buttonIcon: {
      type: String,
      default: null
    },
    successIcon: {
      type: String,
      default: 'check-circle-green.svg'
    },
    errorIcon: {
      type: String,
      default: 'error-circle.svg'
    },
    theme: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    btnShadow: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    postcode: {
      get () {
        return this.$store.getters.getPostcodeInput
      },
      set (value) {
        this.$store.commit('UPDATE_POSTCODE_INPUT', value)
      }
    }
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  methods: {
    submit (result) {
      this.$emit('submit', result)
    }
  }
}
</script>
